import React, {Component} from 'react';
import axios from 'axios';
import {FaBell} from "react-icons/fa";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { Spinner, Button } from 'react-bootstrap';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Alert,
    Badge
} from 'reactstrap';
import defaultUserImage from '../../../../src/assets/img/users/default-user-image.png'; 

class EditTicketComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            btnSubmit: false,
            errorForm: false,
            messageErrorForm: '',
            ticketId: 0,
            title: '',
            content: '',
            status: '',
            user_id: '',
            user_name: '',
            user_avatar: '',
            dateCreated: '',
            ticketDetailLists: [],
            comment: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // console.log(this.props.ticketId)
        this.getDetailTicket( this.props.ticketId );
    }

    getDetailTicket = (ticketId) => {
        this.setState({
            loadPage: true
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/ticket/getDetailTicket/' + ticketId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        loadPage: false,
                        title: ref.data.content.ticket.title,
                        content: ref.data.content.ticket.content,
                        status: ref.data.content.ticket.status,
                        ticketId: ref.data.content.ticket.id,
                        user_id: ref.data.content.ticket.user_id,
                        user_name: ref.data.content.ticket.user_name,
                        user_avatar: ref.data.content.ticket.user_avatar ? ref.data.content.ticket.user_avatar : defaultUserImage,
                        dateCreated: ref.data.content.ticket.dateCreated,
                        ticketDetailLists: ref.data.content.ticketDetailLists
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectError(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu hỗ trợ thất bại',
                })
            })
    }

    redirectError = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.shouldRedirect();
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    submit = () => {
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
                btnSubmit: true,
            })

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                content: this.state.comment,
                ticketId: this.state.ticketId
            };
            axios.post( process.env.REACT_APP_API_URL + '/api/ticket/confirmTicket', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if (ref.data.error === 0) {
                        this.redirect(ref.data.message);
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectError(ref.data.message);
                    }
                    else {
                        if (ref.data.error > 9000) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                loadPage: false,
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo hổ trợ thất bại',
                    })
                })
        }
    }

    redirect = (message) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.shouldRedirect();
    }

    validate = () => {
        if ( this.state.title.length < 5 && this.state.title.length > 50 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Số ký tự của "Vấn đề bạn cần hỗ trợ?" không được nhỏ hơn 5 ký tự hoặc lớn hơn 50 ký tự',
            })
            return false;
        }
        else if ( !this.state.content.length ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Miêu tả chi tiết vấn đề không được để trống',
            })
            return false;
        }
        return true;
    }

    loadBadge = (status) => {
        if ( status === 'Pending' ) {
            return (
                <Badge color="warning">Đang chờ xử lý</Badge>
            )
        }
        else if (status === 'Done') {
            return (
                <Badge color="success">Xử lý hoàn tất</Badge>
            );
        }
        else if (status === 'Processing') {
            return (
                <Badge color="info">Đang xử lý</Badge>
            );
        }
        else if (status === 'Cancel') {
            return (
                <Badge color="danger">Đã hủy</Badge>
            );
        }
    }

    loadTicketDetailLists = () => {
        if ( this.state.ticketDetailLists.length ) {
            return (
                this.state.ticketDetailLists.map( (ticketDetail, key) => {
                    return (
                        <div className="post" key={key}>
                            <div className="user-block">
                                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                                <img src={ ticketDetail.user_avatar ? ticketDetail.user_avatar : defaultUserImage } alt="user image" className="img-circle img-bordered-sm" />
                                <span className="username">
                                    { ticketDetail.user_name }
                                </span>
                                <span className="description">Gửi vào lúc: { ticketDetail.dateCreated }</span>
                            </div>
                            <div style={{ 'display': 'inline-flex' }}>
                                <div dangerouslySetInnerHTML={{ __html: ticketDetail.content }} />
                            </div>
                        </div>
                    )
                })
            );
        }
    }


    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Yêu cầu hỗ trợ"} page={"Hỗ trợ"} icon={<FaBell className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardHeader>
                                    <Link className="btn btn-outline-primary btn-sm" to={'/ho-tro/danh-sach-ho-tro.html'}>
                                        <MdKeyboardArrowLeft /> Danh sách ticket
                                    </Link>
                                </CardHeader>
                                <CardBody>
                                    <div className="col-md-12">
                                        {
                                            this.state.errorForm ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorForm }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </div>

                                    <h5>{ this.state.title } { this.loadBadge(this.state.status) }</h5>
                                    <div className="post">
                                        <div className="user-block">
                                            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                                            <img src={ this.state.user_avatar } alt="user image" className="img-circle img-bordered-sm" />
                                            <span className="username">
                                                { this.state.user_name }
                                            </span>
                                            <span className="description">Gửi vào lúc: { this.state.dateCreated }</span>
                                        </div>
                                        <div>{ this.state.content }</div>
                                    </div>

                                    { this.loadTicketDetailLists() }

                                    <div>
                                        {
                                            this.state.status === 'Processing' ? (
                                                <>
                                                    <FormGroup>
                                                          <CKEditor
                                                              id="content"
                                                              name="content"
                                                              config={{
                                                                  placeholder: "Nhập nội dung phản hồi ..."
                                                              }} 
                                                            editor={ ClassicEditor }
                                                            data={ this.state.comment }
                                                            onChange={ ( event, editor ) => {
                                                                const data = editor.getData();
                                                                this.setState({
                                                                    comment: data
                                                                })
                                                            } }
                                                        />
                                                    </FormGroup>
                                                    <Button 
                                                        className="btn btn-primary btn-sm"
                                                        onClick={ () => this.submit() }
                                                    >
                                                        Phản hồi
                                                      </Button>
                                                </>
                                            ) : (<></>)
                                        }
                                    </div>

                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerTicketEdit' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditTicketComponent);